'use strict';

import $ from 'jquery';
import mediator from '../../js/mediator';
import config from '../../js/config';
import PromotionalGiveawayRegistrationView from './PromotionalGiveawayRegistration';
import PromotionalGiveawayTrivia from './PromotionalGiveawayTrivia';
import PromotionalGiveawayEngineeringQuizView from './PromotionalGiveawayEngineeringQuiz';
import PromotionalGiveawayNotificationBar from './PromotionalGiveawayNotificationBar';

const assignImageSwap = ($el) => {
  const $promotionalGiveawayBannerEl = $el.find('.PromotionalGiveaway-landing-banner-wrapper');
  const imageDesktop = $promotionalGiveawayBannerEl.data('image-desktop');
  const imageMobile = $promotionalGiveawayBannerEl.data('image-mobile');
  let applyImage = (image) => { $promotionalGiveawayBannerEl.css('background-image', 'url(' + image + ')') };
  /* Assigning event handlers */
  mediator.on(config.events.breakpoint.phablet, () => { applyImage(imageMobile) });
  mediator.on(config.events.breakpoint.tablet, () => { applyImage(imageDesktop) });
  /* Setting up default background image */
  if (window.innerWidth <= config.breakpoints.phablet) {
    applyImage(imageMobile);
  } else {
    applyImage(imageDesktop);
  }
}

export function createPromotionalGiveaway($parent) {
  $parent.find('.PromotionalGiveawayTrivia').each((n, el) => {
    new PromotionalGiveawayTrivia($(el));
  });

  $parent.find('.PromotionalGiveaway-EngineerQuiz').each((n, el) => {
    new PromotionalGiveawayEngineeringQuizView({el});
  });

  $parent.find('.PromotionalGiveaway-landing-banner').each((n, el) => {
    assignImageSwap($(el));
  });

  $parent.find('.PromotionalGiveaway-registration').each((n, el) => new PromotionalGiveawayRegistrationView({ el }));

  $parent.find('.PromotionalGiveaway-notificationBar').each((n, el) => new PromotionalGiveawayNotificationBar({ el }));
}



// WEBPACK FOOTER //
// ./assets/components/PromotionalGiveaway/PromotionalGiveaway.js